import React, { createContext, useContext, useState } from 'react';
import {
  FieldAgentsModel,
  FieldAgentsModelData
} from 'src/models/servicePartner/feildAgentModel';
import {
  ServicePartnerGetModel,
  ServicePartnerModel,
  ServicePartnerModelObject
} from 'src/models/servicePartner/servicePartnersModel';
import { ServiceModel } from 'src/models/services/service';
import { ServicePartnerDetailsServices } from 'src/services/servicePartner/sPDetailsService';
import { useCustomerData } from '../customer/customerData';
import { FieldAgentServices } from 'src/services/servicePartner/fieldAgentService';
import { formatDateToDDMMYYYY } from 'src/components/VemigoGrid/dateFormat';
import { ServicePartnerBankAccountsServices } from 'src/services/servicePartner/sPBankAccountsServices';
import {
  BankAccountsModel,
  BankAccountsModelData
} from 'src/models/servicePartner/backAccountModel';
import { ServicePartnerPaymentHistoryModel } from 'src/models/servicePartner/servicePartnerPaymentHistoryModel';
import { ServicePartnerPaymentHistoryModelData } from 'src/models/servicePartner/servicePartnerPaymentHistoryModel';
import { ServicePartnerPaymentHistoryServices } from 'src/services/servicePartner/sPPaymentHistoryServices';


interface ServicePartnerContextValue {
  handleGetServiceConfigList: (data: ServicePartnerModel, get: string) => void;
  handleGetBankAccountsList: (data: number, get: string) => void;
  // handleGetServicePartnerPaymentHistoryList: (data: number, get: string) => void;
  handleGetServicePartnerServicePrice: () => void;
  handleFeildAgentList: (data: number, get: string) => void;
  handleServicePartner: (data: ServicePartnerGetModel) => void;
  handleGetAllServicePartners: (get?: string) => Promise<void>;
  setAllServicePartners: (data: ServicePartnerModel[]) => void;
  setServicePartner: (data: ServicePartnerModel) => void;
  setServicePartnerContact: (data: number) => void;
  setServiceList: (data: ServiceModel[]) => void;
  setBankAccountsList: (data: BankAccountsModel[]) => void;
  setServicePartnerName: (data: string) => void;
  setCarCaregoryPrices: (data: any[]) => void;
  setReadOnly: (data: boolean) => void;
  setFieldAgentList: (data: FieldAgentsModel[]) => void;
  setFieldAgent: (data: FieldAgentsModel) => void;
  setBankAccounts: (data: BankAccountsModel) => void;
  handleFetchServiceOrders: (spId: number, startDate: string, endDate: string) => void;
  setServicePartnerPaymentHistory: (data: any) => void;
  selectedDates: string[];
  setSelectedDates: (dates: string[]) => void;
  serviceOrders: any[];
  bankAccountsList: BankAccountsModel[];
  servicePartnerPaymentHistoryList: ServicePartnerPaymentHistoryModel[];
  servicePartnerPaymentHistory: ServicePartnerPaymentHistoryModel;
  fieldAgentList: FieldAgentsModel[];
  allServicePartners: ServicePartnerModel[];
  servicePartner: ServicePartnerModel;
  bankAccounts: BankAccountsModel;
  servicePartnerContact: number;
  fieldAgent: FieldAgentsModel;
  serviceList: ServiceModel[];
  servicePartnerName: string;
  carCaregoryPrices: any[];
  readOnly: boolean;
}
 
const ServicePartnerContext = createContext<
  ServicePartnerContextValue | undefined
>(undefined);
 
export const useServicePartnerData = () => {
  const context = useContext(ServicePartnerContext);
  if (!context) {
    throw new Error(
      'useServicePartnerData must be used within a ServicePartnerProvider'
    );
  }
  return context;
};
 
export const ServicePartnerProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { allServices } = useCustomerData();
 
  const [servicePartnerName, setServicePartnerName] = useState<string>('');
  const [servicePartnerContact, setServicePartnerContact] = useState<number>(0);
  const [allServicePartners, setAllServicePartners] =
    useState<ServicePartnerModel[]>([]);
  const [servicePartner, setServicePartner] = useState<ServicePartnerModel>(
    ServicePartnerModelObject
  );
  const [fieldAgentList, setFieldAgentList] = useState<FieldAgentsModel[]>([]);
  const [fieldAgent, setFieldAgent] =
    useState<FieldAgentsModel>(FieldAgentsModelData);
  const [serviceList, setServiceList] = useState<ServiceModel[]>([]);
  const [bankAccountsList, setBankAccountsList] = useState<BankAccountsModel[]>(
    []
  );
  const [bankAccounts, setBankAccounts] = useState<BankAccountsModel>(
    BankAccountsModelData
  );
  const [servicePartnerPaymentHistoryList, setservicePartnerPaymentHistoryList] = useState<ServicePartnerPaymentHistoryModel[]>(
    []
  );
  const [servicePartnerPaymentHistory, setServicePartnerPaymentHistory] = useState<ServicePartnerPaymentHistoryModel>(
    ServicePartnerPaymentHistoryModelData
  );
  const [serviceOrders, setServiceOrders] = useState<any[]>([]);
 
  const [carCaregoryPrices, setCarCaregoryPrices] = useState([]);
 
  const [selectedDates, setSelectedDates] = useState<string[]>([]);
 
  const [readOnly, setReadOnly] = useState(false);
 
  const handleGetAllServicePartners = async (get = '') => {
 
    if (allServicePartners.length === 0 || get === 'Get') {
 
      const partners = await ServicePartnerDetailsServices.getAllData();
 
      const list = Array.isArray(partners)
        ? partners.filter(
          (sp) => sp.isActive === true
        )
        : [];
 
      setAllServicePartners(list);
    }
  };
 
  const handleFeildAgentList = async (dataId, get = '') => {
    if (fieldAgentList.length === 0 || get === 'Get') {
      const dataList = await FieldAgentServices.getAllData(dataId);
      const modData = dataList.map((item) => {
        return {
          ...item,
          dateOfJoining: formatDateToDDMMYYYY(item.dateOfJoining)
        };
      });
      setFieldAgentList(modData);
    }
  };
 
  const handleFetchServiceOrders = async (spId: number, startDate: string, endDate: string) => {
    try {
      const data = await ServicePartnerDetailsServices.getServiceOrdersOfSP(spId, startDate, endDate);
      setServiceOrders(data);
    } catch (error) {
      console.error('Error fetching service orders: ', error);
    }
  }
 
  // const handleGetServicePartnerPaymentHistoryList = async (data, get = '') => {
  //   if (serviceList.length === 0 || get === 'Get') {
  //     const dataList =
  //       await ServicePartnerPaymentHistoryServices.getAllData(data);
  //       setservicePartnerPaymentHistoryList(dataList);
  //   }
  // };
 
  const handleGetServiceConfigList = async (data, get = '') => {
    if (serviceList.length === 0 || get === 'Get') {
      const services = await ServicePartnerDetailsServices.getServiceConfig(
        data.id
      );
 
      const modList = services.map((s) => {
        return allServices.find((as) => as.id === s.serviceId);
      }).filter(service => service !== undefined);
 
      setServiceList(modList);
    }
  };
 
  const handleGetBankAccountsList = async (servicePartnerId: number, get = 'Get') => {
    try {
 
      const dataList = await ServicePartnerBankAccountsServices.getAllData(servicePartnerId);
      const list = Array.isArray(dataList) ? dataList : [];
      setBankAccountsList(list);
    } catch (error) {
      console.error('Error fetching bank accounts:', error);
      setBankAccountsList([]);
    }
  };
 
  const handleGetServicePartnerServicePrice = async () => {
    const res = await ServicePartnerDetailsServices.getAllServicePrices();
    setCarCaregoryPrices(res)
  }
 
  const handleServicePartner = (data: ServicePartnerGetModel) => {
    const mappedData: ServicePartnerModel = {
      id: data.id,
      businessName: data.businessName,
      ownerFirstandLastName: data.ownerFirstandLastName,
      ownerMobileNumber: data.ownerMobileNumber,
      ownerEmailId: data.ownerEmailId,
      defaultCityID: data.defaultCity?.id || 0,
      defaultAreaID: data.defaultArea?.id || 0,
      serviceTypeId: data.serviceType?.id || 1,
      preferredPaymentMethod: data?.preferredPaymentMethod || '',
      address: data.address,
      landmark: data.landmark,
      latitude: data.geoLocation?.latitude || 0,
      longitude: data.geoLocation?.longitude || 0,
      contactPerson: data.contactPerson,
      contactNumber1: data.contactNumber1 || '',
      contactNumber2: data.contactNumber2 || '',
      registrationNumber: data.registrationNumber || '',
      gstNumber: data.gstNumber || '',
      isActive: data.isActive,
      referralCode: data.referralCode,
    };
 
    setBankAccountsList([]);
    setFieldAgentList([]);
    setServiceList([]);
    setServiceOrders([]);
    setSelectedDates([]);
    setServicePartner(mappedData);
 
    handleGetServiceConfigList(mappedData, "Get");
    handleFeildAgentList(data.id, "Get");
    handleGetBankAccountsList(data.id);
    handleGetServicePartnerServicePrice()
  };
 
 
 
  return (
    <ServicePartnerContext.Provider
      value={{
        handleGetServiceConfigList,
        handleGetBankAccountsList,
        setServicePartnerContact,
        handleGetServicePartnerServicePrice,
        handleGetAllServicePartners,
        // handleGetServicePartnerPaymentHistoryList,
        handleFeildAgentList,
        handleServicePartner,
        servicePartnerContact,
        setServicePartnerName,
        serviceOrders,
        handleFetchServiceOrders,
        setCarCaregoryPrices,
        setBankAccountsList,
        servicePartnerName,
        setAllServicePartners,
        setServicePartner,
        setFieldAgentList,
        carCaregoryPrices,
        bankAccountsList,
        setBankAccounts,
        servicePartnerPaymentHistoryList,
        servicePartnerPaymentHistory,
        setServicePartnerPaymentHistory,
        servicePartner,
        allServicePartners,
        setServiceList,
        fieldAgentList,
        setFieldAgent,
        bankAccounts,
        serviceList,
        setReadOnly,
        fieldAgent,
        selectedDates,
        setSelectedDates,
        readOnly
      }}
    >
      {children}
    </ServicePartnerContext.Provider>
  );
};
 